/**
 * @desc 调拨批次单导出pod文件
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationBatch.exportPod.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/exportPodFile`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
